import React, {useState, useEffect} from 'react'
import {
    Drawer,
    DrawerOverlay,
    Button,
    Text,
    DrawerContent,
    DrawerBody,
    DrawerHeader,
    DrawerFooter,
    Stack,
    useStyleConfig,
    useBreakpointValue,
    Box,
} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import Refinements from './refinements'
import SortByAccordionItem from './sort-by-accordion'
import PropTypes from 'prop-types'
import CloseIcon from '../../../components/icons/action/CloseIcon'
import LoadingSpinner from '../../../components/loading-spinner'

export default function ProductFilterDrawer({
    searchParams,
    productSearchResult,
    selectedSortingOptionLabel,
    sortUrls,
    isOpen,
    onClose,
    filtersLoading,
    toggleFilter,
    resetFilters,
}) {
    const refinements = productSearchResult?.refinements ?? []
    const refine = searchParams?.refine ?? []
    const style = useStyleConfig('ProductFilterDrawer')
    const [buttonVariant, setButtonVariant] = useState(['primary', true])
    const drawerPlacement = useBreakpointValue({base: 'bottom', md: 'right'})

    useEffect(() => {
        if (Object.keys(searchParams.refine).length === 0) setButtonVariant(['primary', true])
        else setButtonVariant(['secondary', false])
    }, [searchParams.refine])

    return (
        <Drawer variant="filter" placement={drawerPlacement} onClose={onClose} isOpen={isOpen}>
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader {...style?.header}>
                    <Text {...style?.headerText}>
                        <FormattedMessage
                            defaultMessage="Filter and Sort"
                            id="product_list.modal.title.filter"
                        />
                    </Text>
                    <CloseIcon onClick={onClose} {...style?.closeButton} />
                </DrawerHeader>
                <DrawerBody {...style.body}>
                    {filtersLoading && <LoadingSpinner />}
                    <Refinements
                        width="100%"
                        toggleFilter={toggleFilter}
                        filters={refinements}
                        selectedFilters={refine}
                        isOpen={isOpen}
                        itemsBefore={[
                            <>
                                <SortByAccordionItem
                                    width="100%"
                                    key="sortby"
                                    selectedSortingOptionLabel={selectedSortingOptionLabel}
                                    sortUrls={sortUrls}
                                    productSearchResult={productSearchResult}
                                />
                                <Box {...style?.border} />
                            </>,
                        ]}
                        excludedFilters={['cgid']}
                    />
                </DrawerBody>
                <DrawerFooter display="block" width="full">
                    <Stack>
                        <Button width="full" variant="primary" onClick={onClose}>
                            <FormattedMessage
                                defaultMessage="Apply filters"
                                id="product_list.modal.button.apply_filters"
                            />
                        </Button>
                        <Button
                            onClick={resetFilters}
                            width="full"
                            variant={buttonVariant[0]}
                            isDisabled={buttonVariant[1]}
                        >
                            <FormattedMessage
                                defaultMessage="Remove filters"
                                id="product_list.modal.button.remove_filters"
                            />
                        </Button>
                    </Stack>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    )
}

ProductFilterDrawer.propTypes = {
    searchParams: PropTypes.object,
    productSearchResult: PropTypes.object,
    selectedSortingOptionLabel: PropTypes.object,
    sortUrls: PropTypes.array,
    category: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    filtersLoading: PropTypes.bool,
    toggleFilter: PropTypes.func,
    resetFilters: PropTypes.func,
}
